<template>
  <div class="page theme-transition">
    <BackNavigationBar :back="back" :title="title" :hide-button="hideBackButton"/>
    <div class="page-content">
      <slot />
    </div>
  </div>
</template>

<script>
import BackNavigationBar from "@/components/layout/navigation/BackNavigationBar";
export default {
name: "PageWithBackBtn",
  components: {BackNavigationBar},
  props : {
    back : {
      type : Function,
      default : function () { this.$router.back() }
    },
    hideBackButton : {
      type : Boolean,
      default : false,
    },
    title : {
      type : String,
      required : true
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  background: var(--bg-gradient);
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  font-family: var(--font-family);
  transition: var(--transition-speed);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.page-content {
  flex: 1;
  padding: 16px 0;
  animation: fadeIn 0.4s ease;
}

// Animation
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// Responsive Design
@media (max-width: 768px) {
  .page-content {
    padding: 12px 0;
  }
}

@media (max-width: 480px) {
  .page-content {
    padding: 8px 0;
  }
}

// Theme transition support
.theme-transition {
  transition: background 0.8s ease, color 0.8s ease;
}

.theme-transition * {
  transition: background-color 0.8s ease, color 0.8s ease, border-color 0.8s ease, box-shadow 0.8s ease;
}

// Scrollbar styling for webkit browsers
.page::-webkit-scrollbar {
  width: 8px;
}

.page::-webkit-scrollbar-track {
  background: var(--secondary-button-bg);
  border-radius: 4px;
}

.page::-webkit-scrollbar-thumb {
  background: var(--accent-electric-blue);
  border-radius: 4px;
  
  &:hover {
    background: var(--accent-electric-blue-dark);
  }
}

// Focus states for accessibility
.page:focus-within {
  outline: none;
}

// Print styles
@media print {
  .page {
    background: white;
    overflow: visible;
  }
  
  .page-content {
    padding: 0;
  }
}
</style>